export const API_PRODUCT_LISTING_SUCCESS = "API_PRODUCT_LISTING_SUCCESS";
export const API_PRODUCT_LISTING_ERROR = "API_PRODUCT_LISTING_ERROR";
export const GET_PRODUCTLISTING = "GET_PRODUCTLISTING";
export const GET_PRODUCTLISTING_CATEGORY = "GET_PRODUCTLISTING_CATEGORY";
export const GET_PRODUCTLISTING_BRAND = "GET_PRODUCTLISTING_BRAND";
export const GET_PRODUCTLISTING_PARTS = "GET_PRODUCTLISTING_PARTS";
export const GET_PRODUCTLISTING_FILTER = "GET_PRODUCTLISTING_FILTER";
export const SET_PRODUCT_FILTER = 'SET_PRODUCT_FILTER';